import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar({ cartCount = 0 }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-inner" style={{ position: 'relative' }}>
        <Link to="/" className="navbar-brand" onClick={() => setMenuOpen(false)}>
          <img src="/images/man.jpg" alt="Scott Mason" onError={e => { e.target.style.display='none'; }} />
          Scott Mason
        </Link>

        <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li>
            <Link to="/" className={isActive('/')} onClick={() => setMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/order-products" className={isActive('/order-products')} onClick={() => setMenuOpen(false)}>
              Order Products
            </Link>
          </li>
          <li>
            <Link to="/solution-architect" className={isActive('/solution-architect')} onClick={() => setMenuOpen(false)}>
              Solution Architect
            </Link>
          </li>
          <li>
            <Link to="/project-leadership" className={isActive('/project-leadership')} onClick={() => setMenuOpen(false)}>
              Project Leadership
            </Link>
          </li>
          <li>
            <Link to="/about" className={isActive('/about')} onClick={() => setMenuOpen(false)}>
              About
            </Link>
          </li>

          {/* Admin dropdown */}
          <li
            className="nav-dropdown"
            onMouseEnter={() => setAdminOpen(true)}
            onMouseLeave={() => setAdminOpen(false)}
          >
            <a href="#admin" onClick={e => e.preventDefault()} style={{ cursor: 'pointer' }}>
              Admin ▾
            </a>
            {adminOpen && (
              <div className="nav-dropdown-menu">
                <Link to="/admin/categories" onClick={() => { setMenuOpen(false); setAdminOpen(false); }}>Categories</Link>
                <Link to="/admin/products" onClick={() => { setMenuOpen(false); setAdminOpen(false); }}>Products</Link>
                <Link to="/admin/companies" onClick={() => { setMenuOpen(false); setAdminOpen(false); }}>Companies</Link>
                <Link to="/admin/orders" onClick={() => { setMenuOpen(false); setAdminOpen(false); }}>Manage Orders</Link>
                <Link to="/admin/users" onClick={() => { setMenuOpen(false); setAdminOpen(false); }}>Manage Users</Link>
              </div>
            )}
          </li>

          <li>
            <Link to="/cart" className={isActive('/cart')} onClick={() => setMenuOpen(false)}>
              🛒 {cartCount > 0 && <span className="badge" style={{ marginLeft: 4 }}>{cartCount}</span>}
            </Link>
          </li>

          <li>
            <Link to="/login" onClick={() => setMenuOpen(false)} style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem' }}>
              Login / Register
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
